export const BulkFulfillmentTypeMap = {
  Mixed: 'Mixed',
  Label: 'Label',
  External: 'External',
};
